import Text from "components/Text";
import styled, { css } from "styled-components";
import { colors } from "theme/colors";
import leftIcon from "../../icons/LeftArrow.svg";
import rightIcon from "../../icons/RightArrow.svg";

export const getRangeInputStyles = (position: string) => css`
    appearance: none;
    pointer-events: none;
    position: absolute;
    height: 0;
    outline: none;
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        -webkit-tap-highlight-color: transparent;
        border-radius: 50%;
        cursor: pointer;
        pointer-events: all;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url(${position === "left" ? leftIcon : rightIcon}), #fff;
        background-size: cover;
        background-repeat: no-repeat;
    }
    &::-moz-range-thumb {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
        position: relative;
    }
`;

export const MinRangeInput = styled.input<{
    bringToFront: boolean;
}>`
    ${() => getRangeInputStyles("left")}
    z-index: ${({ bringToFront }) => (bringToFront ? "5" : "3")};
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
`;

export const MaxRangeInput = styled.input`
    ${() => getRangeInputStyles("right")}
    z-index: 4;
    top: 50%;
    right: -5px;
    transform: translateY(-50%);
    margin: 0;
`;

export const Slider = styled.div`
    position: relative;
    width: 200px;
`;

export const SliderTrack = styled.div`
    position: absolute;
    border-radius: 3px;
    height: 100%;
    background-color: #ced4da;
    width: 100%;
    z-index: 1;
`;

export const SliderRange = styled.div`
    position: absolute;
    border-radius: 3px;
    height: 100%;
    background-color: ${colors.purple.primary};
    z-index: 2;
`;

export const ValueContainer = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${colors.grey.secondary};
    margin-bottom: 10px;
`;

export const SliderLeftValue = styled(Text)`
    left: 6px;
    font-weight: 500;
`;

export const SliderRightValue = styled(Text)`
    right: -4px;
    font-weight: 500;
`;

export const RangeSelectorWrapper = styled.div<{
    fullWidth?: boolean;
    sliderHeight: number;
}>`
    ${MinRangeInput}, ${MaxRangeInput} {
        width: ${({ fullWidth }) => (fullWidth ? "100%" : "200px")};
        &::-webkit-slider-thumb {
            height: ${({ sliderHeight }) => sliderHeight * 3}px;
            width: ${({ sliderHeight }) => sliderHeight * 3}px;
        }
        &::-moz-range-thumb {
            height: ${({ sliderHeight }) => sliderHeight * 3}px;
            width: ${({ sliderHeight }) => sliderHeight * 3}px;
        }
    }
    ${ValueContainer} {
        width: ${({ fullWidth }) => (fullWidth ? "100%" : "200px")};
    }
    ${Slider} {
        width: ${({ fullWidth }) => (fullWidth ? "100%" : "200px")};
        height: ${({ sliderHeight }) => sliderHeight}px;
    }
`;
